import { createElement } from "react";

import dynamic from "next/dynamic";

import type { SelectionPromptEntry } from "./SelectionPromptInput";
import type { DocumentModel } from "@/models/DocumentModel";

// Lazy to avoid circular dep: useSuggestions → openSelectionPrompt → SelectionPromptInput → TiptapSuggestions → useSuggestions
const LazySelectionPromptInput = dynamic(
  () => import("./SelectionPromptInput").then((m) => ({ default: m.SelectionPromptInput })),
  { ssr: false },
);

/** Open the "Ask AI" popover anchored to the current editor selection. */
export function openSelectionPrompt(doc: DocumentModel, entry: SelectionPromptEntry) {
  doc.editor.suggestions.reset();
  doc.editor.tiptap?.commands.openPopover((close) =>
    createElement(LazySelectionPromptInput, { doc, close, entry }),
  );
}

/** Select the whole top-level line at `pos` and open the "Ask AI" popover over it. */
export function openSelectionPromptForLine(doc: DocumentModel, pos: number) {
  const { tiptap } = doc.editor;
  const node = tiptap?.state.doc.nodeAt(pos);
  if (!tiptap || !node) {
    return;
  }

  if (node.isTextblock) {
    tiptap.commands.setTextSelection({ from: pos + 1, to: pos + node.nodeSize - 1 });
  } else {
    tiptap.commands.setNodeSelection(pos);
  }

  openSelectionPrompt(doc, "line_menu");
}
